import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Items20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path d='M5.5 6.25H14.5V4.75H5.5V6.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.4286 9.25C18.0612 9.25 18.75 8.7813 18.75 8V3C18.75 2.2187 18.0612 1.75 17.4286 1.75H2.57143C1.93883 1.75 1.25 2.2187 1.25 3V8C1.25 8.7813 1.93883 9.25 2.57143 9.25H17.4286ZM17.25 3.25V7.75H2.75V3.25H17.25Z'
      fill='currentColor'
    />
    <path
      d='M6 15.5C6.55228 15.5 7 15.0523 7 14.5C7 13.9477 6.55228 13.5 6 13.5C5.44772 13.5 5 13.9477 5 14.5C5 15.0523 5.44772 15.5 6 15.5Z'
      fill='currentColor'
    />
    <path
      d='M11 14.5C11 15.0523 10.5523 15.5 10 15.5C9.44771 15.5 9 15.0523 9 14.5C9 13.9477 9.44771 13.5 10 13.5C10.5523 13.5 11 13.9477 11 14.5Z'
      fill='currentColor'
    />
    <path
      d='M14 15.5C14.5523 15.5 15 15.0523 15 14.5C15 13.9477 14.5523 13.5 14 13.5C13.4477 13.5 13 13.9477 13 14.5C13 15.0523 13.4477 15.5 14 15.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.4286 18.25C18.0612 18.25 18.75 17.7813 18.75 17V12C18.75 11.2187 18.0612 10.75 17.4286 10.75H2.57143C1.93883 10.75 1.25 11.2187 1.25 12V17C1.25 17.7813 1.93883 18.25 2.57143 18.25H17.4286ZM17.25 12.25V16.75H2.75V12.25H17.25Z'
      fill='currentColor'
    />
  </Svg>
);

Items20.displayName = 'Items20';
export default Items20;
